<template>
    <div class="w-full absolute top-0">
        <main>
<!--        <Header :header_icon_color="header_icon_color"></Header>-->
        <div class="h-screen">
            <video
                v-if="activeHeroOrientation === 'landscape'"
                v-show="show_video"
                key="hero-video-landscape"
                class="hero-image !fixed"
                loop autoplay muted playsinline
                :poster="`/api/files/video/thumbnail/${content?.['hero_video']}?full=true`"
            >
                <source v-if="content?.['hero_video_webm']" :src="`/api/files/video/${content?.['hero_video_webm']}`" />
                <source :src="`/api/files/video/${content?.['hero_video']}`" />
            </video>

            <video
                v-else
                v-show="show_video"
                key="hero-video-portrait"
                class="hero-image !fixed"
                loop autoplay muted playsinline
                :poster="`/api/files/video/thumbnail/${content?.['hero_video_portrait']}?full=true`"
            >
                <source v-if="content?.['hero_video_portrait_webm']" :src="`/api/files/video/${content?.['hero_video_portrait_webm']}`" />
                <source :src="`/api/files/video/${content?.['hero_video_portrait']}`" />
            </video>
            <div
                class="relative z-10 flex flex-col items-start justify-end h-full text-white text-left container"
            >
                <div
                    class="absolute bottom-14 opacity-0 w-5 h-1"
                    ref="elementRef"
                />
            </div>
        </div>
        <div ref="videoTrackingElement" class="opacity-0 absolute top-0 left-0 h-screen w-full bg-red-500"></div>

        <div class="relative bg-background flex flex-col gap-32 py-16 items-center">
            <section class="container flex flex-col gap-8" aria-labelledby="homepage-title">
                <h1 id="homepage-title" class="view-h1 col-span-full">{{ get_localized_value(content.title) }}</h1>
                <div class="max-w-xl lg:col-start-2 md:col-span-9">{{ get_localized_value(content.intro) }}</div>
<!--                <pre class="text-wrap">{{content}}</pre>-->
            </section>

            <TitleWithLink heading-id="featured-projects-heading" :title="t('featured-projects.title')" :link="{url: localePath('/work'), label: t('featured-projects.button')}">
                <div class="flex flex-col md:grid md:grid-cols-12 gap-4 container">
                    <CaseItem
                        v-if="featured_projects.project_1?.data"
                        :title="get_localized_value(featured_projects.project_1.data.title)"
                        :credit="get_localized_value(featured_projects.project_1.data.credits?.['client_and_location'])"
                        :image="featured_projects.project_1.data?.['hero-image']"
                        :size="CaseItemWidth.small"
                        :contentId="featured_projects.project_1?.contentId.toString()"
                        :slug="featured_projects.project_1.data.slug"
                        class="!col-start-1"
                    />

                    <CaseItem
                        v-if="featured_projects.project_2?.data"
                        :title="get_localized_value(featured_projects.project_2.data.title)"
                        :credit="get_localized_value(featured_projects.project_2.data.credits?.['client_and_location'])"
                        :image="featured_projects.project_2.data?.['hero-image']"
                        :size="CaseItemWidth.small"
                        :contentId="featured_projects.project_2?.contentId.toString()"
                        :slug="featured_projects.project_2.data.slug"
                    />

                    <CaseItem
                        v-if="featured_projects.project_3?.data"
                        :title="get_localized_value(featured_projects.project_3.data.title)"
                        :credit="get_localized_value(featured_projects.project_3.data.credits?.['client_and_location'])"
                        :image="featured_projects.project_3.data?.['hero-image']"
                        :size="CaseItemWidth.small"
                        :contentId="featured_projects.project_3.contentId.toString()"
                        :slug="featured_projects.project_3.data.slug"
                    />
                </div>
            </TitleWithLink>

            <TitleWithLink heading-id="what-we-do-heading" :title="t('what-we-do.title')" :link="{url: localePath('/about'), label: t('what-we-do.button')}">
                <div class="flex flex-col gap-16">
                    <div class="grid grid-cols-12">
                        <div class="col-span-12 md:col-span-7 lg:col-start-2">
                            <RenderedHTML :value="content['what-we-do']['body']"/>
                        </div>

                    </div>
                    <DuoParalaxImages
                        :content="{
                            'image-left': content['what-we-do']['image-left'],
                            'image-right': content['what-we-do']['image-right']
                        }"/>
                </div>
            </TitleWithLink>

            <section class="flex flex-col gap-8 w-full" aria-labelledby="our-clients-heading">
                <BlockText heading-id="our-clients-heading" :content="{title: t('our-clients'), body: content['our-clients'].body}"/>
<!--                <div class="view-h2 container self-center">{{t('our-clients')}}</div>-->
<!--                <div class="container flex self-center ">-->
<!--                    <div class="max-w-9/12 flex self-start">-->
<!--                        <RenderedHTML :value="content['our-clients'].body"></RenderedHTML>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="bg-view-sand-light">
                    <AnimatedImageCarousel :images="content['our-clients']['logos'].map((content: any) => content.image)" />
                </div>
            </section>

            <section class="container-large" aria-labelledby="contact-heading">
                <ContactBannerMoreInfo heading-id="contact-heading" :title="get_localized_value(content.contact.title)" :profile-picture="content.contact['profile-picture']" :text="get_localized_value(content.contact.text)"/>

            </section>
        </div>
        </main>
        <Footer ></Footer>
    </div>
</template>

<script setup lang="ts">
import TitleWithLink from "~/components/view/ContainerWithTitleWithLink.vue"
import DuoParalaxImages from "~/components/view/DuoParalaxImages.vue"
import RenderedHTML from "~/components/view/RenderedHTML.vue"
import AnimatedImageCarousel from "~/components/view/AnimatedImageCarousel.vue"
import ContactBannerMoreInfo from "~/components/view/ContactBannerMoreInfo.vue"
import CaseItem, { CaseItemWidth } from "~/components/view/CaseItem.vue"
import { Pages } from "#shared/types/Pages"
import Footer from "~/components/view/Footer.vue"
import BlockText from "~/components/view/BlockText.vue"
import type { ApiResponse } from "#layers/cms/shared/types/ApiResponse"
import type { BucketData } from "#layers/cms/shared/types/bucketData"

const siteStore = useSiteStore()
const textUtils = useTextUtils()
const { get_value: get_localized_value } = useLocalizedValue()
const { t, locale } = useI18n({useScope: 'local'})
const localePath = useLocalePath()
const config = useRuntimeConfig()

const show_video = ref(true)
const videoEl = ref()

const {elementRef: elementRef } = useInViewport({
    threshold: 0,
    onEnter: () => {
        siteStore.setIconColor('light')
    },
    onLeave: () => {
        siteStore.setIconColor('dark')
    },
})
const { isPortrait } = useOrientationVideo()
const activeHeroOrientation = computed(() => (
    isPortrait.value && content?.['hero_video_portrait'] ? 'portrait' : 'landscape'
))

definePageMeta({
    layout: 'view',
    pageTransition: {
        onBeforeEnter: (el) => {
            if (window) window.scroll({top: 0})
        }
    }
})

const siteUrl = String(config.public.publicHost || 'https://yipp.nl').replace(/\/$/, '')
const canonicalUrl = computed(() => `${siteUrl}${localePath('/', locale.value)}`)
const organizationId = `${siteUrl}/#organization`
const websiteId = `${siteUrl}/#website`
const structuredData = computed(() => ({
    '@context': 'https://schema.org',
    '@graph': [
        {
            '@type': 'Organization',
            '@id': organizationId,
            name: 'YIPP',
            url: `${siteUrl}/`,
            logo: {
                '@type': 'ImageObject',
                url: `${siteUrl}/assets/images/yipp_logo_yipp.svg`
            },
            email: 'info@yipp.nl',
            telephone: '+31 20 820 2348',
            address: {
                '@type': 'PostalAddress',
                streetAddress: 'Zeeburgerpad 5',
                postalCode: '1018 AH',
                addressLocality: 'Amsterdam',
                addressCountry: 'NL'
            },
            contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'general inquiries',
                email: 'info@yipp.nl',
                telephone: '+31 20 820 2348',
                availableLanguage: ['English', 'Dutch']
            },
            sameAs: [
                'https://nl.linkedin.com/company/yipp-interactive',
                'https://www.instagram.com/yippinteractive/',
                'https://www.youtube.com/@yippinteractive'
            ]
        },
        {
            '@type': 'WebSite',
            '@id': websiteId,
            url: `${siteUrl}/`,
            name: 'YIPP',
            inLanguage: ['en-GB', 'nl-NL'],
            publisher: {
                '@id': organizationId
            }
        }
    ]
}))

useHead(() => ({
    title: t('seo.title'),
    script: [{
        key: 'homepage-structured-data',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(structuredData.value).replace(/</g, '\\u003c')
    }]
}))

useSeoMeta({
    description: () => t('seo.description'),
    ogTitle: () => t('seo.title'),
    ogDescription: () => t('seo.description'),
    ogUrl: () => canonicalUrl.value,
    twitterTitle: () => t('seo.title'),
    twitterDescription: () => t('seo.description')
})

const { data: response } = await useAsyncData(
    'website-homepage',
    () => $fetch<ApiResponse<BucketData>>(
        '/api/bucketContent/website-homepage/latest'
    )
)

if (!response.value) throw createError('Homepage content could not be loaded')
if (!response.value.success)throw createError(response.value.message)

const content = response.value.data.data

const retrieveCase = async (key?: string): Promise<BucketData | null> => {
    if (!key) return null

    const result = await $fetch<ApiResponse<BucketData>>(
        `/api/bucketContent/website-cases/${key}?filter=title,hero-image,credits,slug`
    )

    return result.success ? result.data : null
}

const { data: featured_projects } = await useAsyncData(
    'website-homepage-featured-projects',
    async () => {
        const [project_1, project_2, project_3] = await Promise.all([
            retrieveCase(content.featured_projects?.['project-1']),
            retrieveCase(content.featured_projects?.['project-2']),
            retrieveCase(content.featured_projects?.['project-3'])
        ])

        return { project_1, project_2, project_3 }
    },
    {
        default: () => ({
            project_1: null,
            project_2: null,
            project_3: null
        })
    }
)


const {elementRef: videoTrackingElement } = useInViewport({
    threshold: 0,
    onEnter: () => {
        // siteStore.setIconColor('light')
        show_video.value = true
    },
    onLeave: () => {
        // siteStore.setIconColor('dark')
        show_video.value = false
    },
})

onMounted(() => {
    siteStore.setCurrentPage(Pages.HOME)
})

</script>

<i18n lang="yaml">
en:
    seo:
        title: "Digital Exhibition & Immersive Studio"
        description: "We design and produce playful digital interactives for a world of curious people."
    featured-projects:
        title:  Featured Projects
        button: Go to all projects
    what-we-do:
        title:  What we do
        button: Learn more about us
    our-clients: Our clients
nl:
    seo:
        title: "Digitale tentoonstellingen & immersieve studio"
        description: "We ontwerpen en produceren speelse digitale interacties voor een wereld vol nieuwsgierige mensen."
    featured-projects:
        title:  Geselecteerde projecten
        button: Ga naar alle projecten
    what-we-do:
        title:  Wat we doen
        button: Leer meer over ons
    our-clients: Onze klanten
</i18n>
